<div class="tw-sticky tw-top-0 tw-z-10">
    <ui-header [type]="type()">
        <ng-content
            left
            select="[slot=start]"></ng-content>
        <div middle>
            <ui-label
                leadingIcon="logo-colored"
                weight="bold"
                >Dynamic advertising</ui-label
            >
        </div>
        <div
            right
            class="tw-flex">
            <ng-content
                right
                select="[slot=end]"></ng-content>
            @if (environment.stage === 'sandbox') {
                <div class="tw-flex tw-items-center tw-mx-nui-400">
                    <ui-pr-env-picker (prEnvClicked)="onPrEnvClicked($event)" />
                </div>
            }
        </div>
    </ui-header>
</div>
